import styled from 'styled-components';

export const StyledLabel = styled.label`
  text-transform: uppercase;
  margin-bottom: 0.1875rem;
`;
